export const translations = {
  en: {
    app_name: "Obra",
    tagline: "Build with clarity.",
    hero_sub: "Track subcontractors, deliveries and site issues across every active project — in one calm command center.",
    get_started: "Get started",
    sign_in: "Sign in",
    sign_up: "Sign up",
    sign_out: "Sign out",
    email: "Email",
    password: "Password",
    name: "Full name",
    login_title: "Welcome back",
    login_sub: "Sign in to continue managing your sites.",
    register_title: "Create your account",
    register_sub: "Start managing projects, timelines and snags.",
    have_account: "Already have an account?",
    no_account: "Don't have an account?",
    projects: "Projects",
    timeline: "Timeline",
    snags: "Snagging",
    dashboard: "Dashboard",
    new_project: "New project",
    active_projects: "Active projects",
    all_projects: "All projects",
    project_name: "Project name",
    client: "Client",
    address: "Address",
    status: "Status",
    start_date: "Start date",
    end_date: "End date",
    progress: "Progress",
    budget: "Budget",
    description: "Description",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    open: "Open",
    in_progress: "In progress",
    completed: "Completed",
    planning: "Planning",
    on_hold: "On hold",
    resolved: "Resolved",
    scheduled: "Scheduled",
    done: "Done",
    delayed: "Delayed",
    new_snag: "New snag",
    snag_title: "Issue title",
    location: "Location",
    priority: "Priority",
    low: "Low", medium: "Medium", high: "High", critical: "Critical",
    assigned_to: "Assigned to",
    upload_photo: "Upload photo",
    drop_photo: "Drop image or click to upload",
    ai_assistant: "AI Assistant",
    summarize: "Summarize",
    suggest_resolution: "Suggest resolution",
    ai_summary: "AI Summary",
    ai_resolution: "Resolution steps",
    select_model: "Model",
    new_event: "New event",
    delivery: "Delivery",
    subcontractor: "Subcontractor",
    milestone: "Milestone",
    event_title: "Event title",
    contractor: "Contractor / Supplier",
    notes: "Notes",
    type: "Type",
    no_projects: "No projects yet. Create your first project to get started.",
    no_snags: "No snags reported. Your site is looking clean.",
    no_events: "No timeline events scheduled.",
    total_snags: "Total snags",
    open_snags: "Open snags",
    critical_snags: "Critical",
    upcoming: "Upcoming this week",
    all: "All",
    filter_project: "Filter by project",
    generating: "Generating…",
    photo: "Photo",
    click_to_generate: "Click Summarize or Suggest resolution to get AI insights.",
    weeks_ahead: "Next 6 weeks",
    today: "Today",
    open_project: "Open",
    // Notifications & project detail
    notifications: "Notifications",
    unread: "unread",
    all_caught_up: "All caught up",
    mark_all_read: "Mark all read",
    no_notifications: "No notifications yet.",
    overview: "Overview",
    timeline_events: "Timeline events",
    site_managers: "Site managers",
    none_configured: "None configured",
    no_description: "No description yet.",
    edit_project: "Edit project",
    saved: "Saved",
    deleted: "Deleted",
    delete_project_confirm: "Delete this project? All its timeline events and snags will also be removed.",
    delete_snag_confirm: "Delete this snag?",
    delete_event_confirm: "Delete this event?",
    photo_uploaded: "Photo uploaded",
    title_required: "Title is required",
    fill_event_required: "Fill title and start date",
    snag_created: "Snag created",
    event_added: "Event added",
    critical_notified: "Critical snag flagged — site managers notified",
    critical_will_email: "Site managers will be emailed on save",
    no_managers_hint: "Add manager emails in Edit — they'll be alerted on critical snags.",
    site_managers_hint: "Comma-separated emails. Alerts go out when a snag is marked critical.",
    comma_separated_emails: "comma-separated",
    // Weather & PDF
    weather: "Weather",
    weather_no_location: "Set a project location to see the on-site forecast.",
    set_project_location: "Set project location",
    latitude: "Latitude",
    longitude: "Longitude",
    detect: "Detect",
    geocode_need_address: "Enter an address first",
    geocode_none: "No match found for that address",
    export_pdf: "Export PDF",
    // Billing
    billing: "Billing",
    support: "Support",
    admin: "Admin",
    admin_title: "All accounts",
    admin_sub: "Everyone who has signed up for Obra — with plan, activity and creation date.",
    total_users: "Total users",
    plan_free: "Free",
    plan_bronze: "Bronze",
    plan_gold: "Gold",
    admins: "Admins",
    search_users: "Search by email, name or plan…",
    name: "Name",
    role: "Role",
    created: "Created",
    last_login: "Last login",
    refresh: "Refresh",
    no_users: "No users yet.",
    no_matching_users: "No users match your search.",
    change_plan: "Change plan (no charge to user)",
    plan_updated: "Plan updated",
    confirm_plan_change: "Set plan for {email} to {plan}? No payment will be taken.",
    manual_badge: "MANUAL",
    manual_plan_tip: "Plan granted manually — no Stripe subscription.",
    stripe_plan_locked: "Paying Stripe subscriber — cancel in Stripe first to change plan.",
    weather_temporarily_unavailable: "Weather service is temporarily unavailable. Try again in a moment.",
    retry: "Retry",
    support_title: "We're here to help",
    support_sub: "Questions, bugs, feedback — reach us directly. We reply personally, usually within one working day.",
    email_us: "Email us",
    follow_us: "Follow us",
    support_email_desc: "Best for account, billing or bug reports. We reply personally within one working day.",
    support_instagram_desc: "Behind-the-scenes, product updates and site stories from the Obra team.",
    copy_email: "Copy email address",
    email_copied: "Email address copied",
    support_response_title: "Typical response time: under 24 hours",
    support_response_desc: "Weekdays, 9:00–19:00 CET. Gold customers get priority handling.",
    choose_plan: "Choose your plan",
    choose_plan_sub: "Start free with 1 project. Upgrade to Bronze for 3, or Gold for unlimited — plus PDF exports and email alerts.",
    current_plan: "Current",
    recommended: "RECOMMENDED",
    most_popular: "MOST POPULAR",
    free_desc: "Manage a small site — the essentials.",
    pro_desc: "Everything a full-time foreman needs.",
    upgrade_to_pro: "Upgrade to Pro",
    upgrade_to: "Upgrade to",
    choose: "Choose",
    downgrade_via_portal: "Downgrade via portal",
    manage_subscription: "Manage subscription",
    your_plan: "Your plan",
    projects_used: "Projects used",
    project_updated: "Project updated",
    project_created: "Project created",
    fill_title_project: "Fill title and project",
    fill_event_title_project_date: "Fill title, project and start date",
    select_snag_prompt: "Select an issue to view details",
    uploading: "Uploading…",
    photo_attached: "Photo attached ✓",
    confirming_payment: "Confirming your payment…",
    usually_seconds: "This usually takes a couple of seconds.",
    welcome_upgraded: "Welcome aboard.",
    account_upgraded: "Your account has been upgraded. Enjoy the extra room for projects, PDF reports and email alerts.",
    go_to_dashboard: "Go to dashboard",
    still_processing: "Still processing…",
    stripe_delayed: "Stripe is taking longer than usual. Your account will be upgraded automatically once confirmed.",
    check_billing: "Check billing",
    didnt_work: "Hmm, that didn't work.",
    payment_confirm_failed: "We couldn't confirm the payment. Please try again from Billing.",
    back_to_billing: "Back to Billing",
    no_worries: "No worries.",
    card_not_charged: "Your card was not charged. You can upgrade anytime from Billing.",
    back_to_dashboard: "Back to dashboard",
    try_again: "Try again",
    tax_note: "Prices in EUR. VAT calculated and included by Stripe at checkout (SMP mode).",
    monthly: "Monthly",
    yearly: "Yearly",
    months_free_short: "MO FREE",
    save_2_months: "Save 2 months",
    free_trial: "Free trial",
    trial_banner_desc: "Try Bronze free for {days} days — full access to snags, PDFs, weather and alerts. No charge if you cancel before day {days}.",
    start_trial: "Start {days}-day free trial",
    cancel_anytime: "Cancel anytime",
    // Weekly AI Client Report
    weekly_report: "Weekly Client Report",
    weekly_report_sub: "An AI-drafted, client-ready summary of progress, upcoming work, open issues and risks.",
    generate_report: "Generate report",
    regenerate_report: "Regenerate",
    generating_report: "Drafting your weekly report…",
    generating_report_sub: "This takes about 20–40 seconds.",
    copy_report: "Copy",
    report_copied: "Report copied to clipboard",
    download_report_pdf: "Download PDF",
    report_generated_at: "Generated",
    no_report_yet: "No report yet — click Generate to draft this week's client report.",
    weekly_report_gold_only: "Weekly Client Reports are a Gold plan feature.",
    weekly_report_gold_desc: "Upgrade to Gold to let AI draft a weekly, client-ready update — every project, every Monday.",
    upgrade_to_gold: "Upgrade to Gold",
    executive_summary: "Executive summary",
    progress_this_week: "Progress this week",
    upcoming_next_week: "Upcoming next week",
    open_issues: "Open issues",
    risks_and_blockers: "Risks & blockers",
    closing_note: "Closing note",
    never_forget_issue: "Never forget a site issue",
  },
  es: {
    app_name: "Obra",
    tagline: "Construye con claridad.",
    hero_sub: "Gestiona subcontratistas, entregas e incidencias de obra en todos tus proyectos activos — en un solo centro de mando.",
    get_started: "Empezar",
    sign_in: "Iniciar sesión",
    sign_up: "Registrarse",
    sign_out: "Cerrar sesión",
    email: "Correo",
    password: "Contraseña",
    name: "Nombre completo",
    login_title: "Bienvenido de vuelta",
    login_sub: "Inicia sesión para continuar gestionando tus obras.",
    register_title: "Crea tu cuenta",
    register_sub: "Comienza a gestionar proyectos, cronograma e incidencias.",
    have_account: "¿Ya tienes cuenta?",
    no_account: "¿No tienes cuenta?",
    projects: "Proyectos",
    timeline: "Cronograma",
    snags: "Incidencias",
    dashboard: "Panel",
    new_project: "Nuevo proyecto",
    active_projects: "Proyectos activos",
    all_projects: "Todos los proyectos",
    project_name: "Nombre del proyecto",
    client: "Cliente",
    address: "Dirección",
    status: "Estado",
    start_date: "Fecha inicio",
    end_date: "Fecha fin",
    progress: "Progreso",
    budget: "Presupuesto",
    description: "Descripción",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    open: "Abierta",
    in_progress: "En curso",
    completed: "Completado",
    planning: "Planificación",
    on_hold: "En pausa",
    resolved: "Resuelta",
    scheduled: "Programado",
    done: "Hecho",
    delayed: "Retrasado",
    new_snag: "Nueva incidencia",
    snag_title: "Título de la incidencia",
    location: "Ubicación",
    priority: "Prioridad",
    low: "Baja", medium: "Media", high: "Alta", critical: "Crítica",
    assigned_to: "Asignado a",
    upload_photo: "Subir foto",
    drop_photo: "Suelta la imagen o haz clic para subir",
    ai_assistant: "Asistente IA",
    summarize: "Resumir",
    suggest_resolution: "Sugerir solución",
    ai_summary: "Resumen IA",
    ai_resolution: "Pasos de resolución",
    select_model: "Modelo",
    new_event: "Nuevo evento",
    delivery: "Entrega",
    subcontractor: "Subcontratista",
    milestone: "Hito",
    event_title: "Título del evento",
    contractor: "Contratista / Proveedor",
    notes: "Notas",
    type: "Tipo",
    no_projects: "Aún no hay proyectos. Crea el primero para empezar.",
    no_snags: "Sin incidencias reportadas. La obra está limpia.",
    no_events: "No hay eventos programados.",
    total_snags: "Total incidencias",
    open_snags: "Abiertas",
    critical_snags: "Críticas",
    upcoming: "Próxima semana",
    all: "Todos",
    filter_project: "Filtrar por proyecto",
    generating: "Generando…",
    photo: "Foto",
    click_to_generate: "Pulsa Resumir o Sugerir solución para obtener ayuda IA.",
    weeks_ahead: "Próximas 6 semanas",
    today: "Hoy",
    open_project: "Abrir",
    // Notifications & project detail
    notifications: "Notificaciones",
    unread: "sin leer",
    all_caught_up: "Al día",
    mark_all_read: "Marcar todas leídas",
    no_notifications: "Sin notificaciones aún.",
    overview: "Resumen",
    timeline_events: "Eventos cronograma",
    site_managers: "Jefes de obra",
    none_configured: "Ninguno configurado",
    no_description: "Sin descripción todavía.",
    edit_project: "Editar proyecto",
    saved: "Guardado",
    deleted: "Eliminado",
    delete_project_confirm: "¿Eliminar este proyecto? También se eliminarán todos sus eventos e incidencias.",
    delete_snag_confirm: "¿Eliminar esta incidencia?",
    delete_event_confirm: "¿Eliminar este evento?",
    photo_uploaded: "Foto subida",
    title_required: "El título es obligatorio",
    fill_event_required: "Rellena título y fecha de inicio",
    snag_created: "Incidencia creada",
    event_added: "Evento añadido",
    critical_notified: "Incidencia crítica registrada — jefes de obra notificados",
    critical_will_email: "Se enviará un correo a los jefes de obra al guardar",
    no_managers_hint: "Añade correos de jefes en Editar — recibirán aviso ante incidencias críticas.",
    site_managers_hint: "Correos separados por comas. Se avisan cuando una incidencia se marca crítica.",
    comma_separated_emails: "separados por comas",
    // Weather & PDF
    weather: "Clima",
    weather_no_location: "Configura la ubicación del proyecto para ver el pronóstico en obra.",
    set_project_location: "Configurar ubicación",
    latitude: "Latitud",
    longitude: "Longitud",
    detect: "Detectar",
    geocode_need_address: "Introduce una dirección primero",
    geocode_none: "No se encontró coincidencia para esa dirección",
    export_pdf: "Exportar PDF",
    // Billing
    billing: "Facturación",
    support: "Soporte",
    admin: "Admin",
    admin_title: "Todas las cuentas",
    admin_sub: "Todos los usuarios registrados en Obra — con plan, actividad y fecha de alta.",
    total_users: "Usuarios totales",
    plan_free: "Free",
    plan_bronze: "Bronze",
    plan_gold: "Gold",
    admins: "Administradores",
    search_users: "Buscar por email, nombre o plan…",
    name: "Nombre",
    role: "Rol",
    created: "Creado",
    last_login: "Último acceso",
    refresh: "Actualizar",
    no_users: "Aún no hay usuarios.",
    no_matching_users: "Ningún usuario coincide con la búsqueda.",
    change_plan: "Cambiar plan (sin cargo al usuario)",
    plan_updated: "Plan actualizado",
    confirm_plan_change: "¿Cambiar el plan de {email} a {plan}? No se cobrará nada.",
    manual_badge: "MANUAL",
    manual_plan_tip: "Plan otorgado manualmente — sin suscripción de Stripe.",
    stripe_plan_locked: "Cliente de pago en Stripe — cancela la suscripción en Stripe antes de cambiar el plan.",
    weather_temporarily_unavailable: "El servicio del tiempo no está disponible ahora mismo. Inténtalo de nuevo en un momento.",
    retry: "Reintentar",
    support_title: "Estamos aquí para ayudarte",
    support_sub: "Dudas, incidencias o feedback — escríbenos directamente. Respondemos en persona, normalmente en menos de un día laborable.",
    email_us: "Escríbenos",
    follow_us: "Síguenos",
    support_email_desc: "Ideal para temas de cuenta, facturación o incidencias. Respondemos en menos de un día laborable.",
    support_instagram_desc: "Detrás de escena, novedades del producto e historias de obra del equipo de Obra.",
    copy_email: "Copiar correo",
    email_copied: "Correo copiado",
    support_response_title: "Tiempo de respuesta habitual: menos de 24 h",
    support_response_desc: "De lunes a viernes, 9:00–19:00 CET. Clientes Gold tienen prioridad.",
    choose_plan: "Elige tu plan",
    choose_plan_sub: "Empieza gratis con 1 proyecto. Actualiza a Bronze para 3, o Gold para ilimitados — con PDF y alertas por email.",
    current_plan: "Actual",
    recommended: "RECOMENDADO",
    most_popular: "MÁS POPULAR",
    free_desc: "Gestiona una obra pequeña — lo esencial.",
    pro_desc: "Todo lo que necesita un jefe de obra a tiempo completo.",
    upgrade_to_pro: "Actualizar a Pro",
    upgrade_to: "Actualizar a",
    choose: "Elegir",
    downgrade_via_portal: "Bajar de plan (portal)",
    manage_subscription: "Gestionar suscripción",
    your_plan: "Tu plan",
    projects_used: "Proyectos usados",
    project_updated: "Proyecto actualizado",
    project_created: "Proyecto creado",
    fill_title_project: "Completa título y proyecto",
    fill_event_title_project_date: "Completa título, proyecto y fecha de inicio",
    select_snag_prompt: "Selecciona una incidencia para ver los detalles",
    uploading: "Subiendo…",
    photo_attached: "Foto adjuntada ✓",
    confirming_payment: "Confirmando el pago…",
    usually_seconds: "Suele tardar solo unos segundos.",
    welcome_upgraded: "Bienvenido a bordo.",
    account_upgraded: "Tu cuenta ha sido actualizada. Disfruta del espacio extra para proyectos, informes PDF y alertas por email.",
    go_to_dashboard: "Ir al panel",
    still_processing: "Aún procesando…",
    stripe_delayed: "Stripe está tardando más de lo habitual. Tu cuenta se actualizará automáticamente cuando se confirme.",
    check_billing: "Ver facturación",
    didnt_work: "Hmm, algo no salió bien.",
    payment_confirm_failed: "No pudimos confirmar el pago. Inténtalo de nuevo desde Facturación.",
    back_to_billing: "Volver a Facturación",
    no_worries: "Tranquilo.",
    card_not_charged: "No se ha realizado ningún cargo. Puedes actualizar cuando quieras desde Facturación.",
    back_to_dashboard: "Volver al panel",
    try_again: "Intentar de nuevo",
    tax_note: "Precios en EUR. El IVA lo calcula e incluye Stripe en el checkout (modo SMP).",
    monthly: "Mensual",
    yearly: "Anual",
    months_free_short: "MESES GRATIS",
    save_2_months: "Ahorra 2 meses",
    free_trial: "Prueba gratuita",
    trial_banner_desc: "Prueba Bronze gratis durante {days} días — acceso total a incidencias, PDF, clima y alertas. Sin cargo si cancelas antes del día {days}.",
    start_trial: "Empezar prueba gratis de {days} días",
    cancel_anytime: "Cancela cuando quieras",
    // Informe semanal (IA)
    weekly_report: "Informe semanal al cliente",
    weekly_report_sub: "Un resumen redactado por IA — listo para el cliente — con avances, próximos pasos, incidencias abiertas y riesgos.",
    generate_report: "Generar informe",
    regenerate_report: "Regenerar",
    generating_report: "Redactando el informe…",
    generating_report_sub: "Suele tardar 20–40 segundos.",
    copy_report: "Copiar",
    report_copied: "Informe copiado al portapapeles",
    download_report_pdf: "Descargar PDF",
    report_generated_at: "Generado",
    no_report_yet: "Aún no hay informe — pulsa Generar para redactar el informe de esta semana.",
    weekly_report_gold_only: "El informe semanal es una función del plan Gold.",
    weekly_report_gold_desc: "Actualiza a Gold y deja que la IA redacte cada semana un informe listo para tu cliente — todos los proyectos, todos los lunes.",
    upgrade_to_gold: "Actualizar a Gold",
    executive_summary: "Resumen ejecutivo",
    progress_this_week: "Avances de la semana",
    upcoming_next_week: "Próxima semana",
    open_issues: "Incidencias abiertas",
    risks_and_blockers: "Riesgos y bloqueos",
    closing_note: "Cierre",
    never_forget_issue: "Nunca olvides una incidencia",
  },
};
